import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cover bg-center bg-fixed" style={{backgroundImage: "url('/home-background.jpg')"}}>
      <div className="absolute inset-0 bg-black bg-opacity-40 backdrop-filter backdrop-blur-sm"></div>
      <div className="relative z-10 text-center px-4 py-16 w-full">
        <img 
          src="/new_munich_girls_logo.png" 
          alt="Munich Girls Book Club Logo" 
          className="mx-auto mb-8 w-[1000px] h-auto"
        />
        <div className="space-y-4 sm:space-y-0 sm:space-x-4">
          <Link 
            to="/login"
            className="inline-block px-6 py-3 bg-purple-600 text-white font-semibold rounded-md hover:bg-purple-700 transition duration-300 w-full sm:w-auto"
          >
            Login
          </Link>
          <Link 
            to="/registration"
            className="inline-block px-6 py-3 bg-white text-purple-600 font-semibold rounded-md hover:bg-gray-100 transition duration-300 w-full sm:w-auto"
          >
            Request to Join
          </Link>
        </div>
        <div className='text-red-500'>
          This website is currently under development and will be accessible shortly!
        </div>
      </div>
    </div>
  );
};

export default Home;